import React from 'react';
import { IonButton, IonIcon, IonItem } from '@ionic/react';
import { FieldError } from '../common';
import { withTranslation } from '../../lib/translate';
import wrong from '../../assets/images/Deli_Wrong.svg';
import { chevronDownOutline } from 'ionicons/icons';


const FieldWrapper = (props) => {
    const { __, children, error, dropdown,disabled } = props
    return (
        <>
            <IonItem lines='none' className={`input-field-wrapper ${error ? 'input-field-wrapper-invalid' : ''} ${dropdown ? 'dropdown-field' : ''} ${disabled?'disabled-wrapper':''}`}>
                {children}
                {error &&
                    <IonButton className='input-validator-button' fill='clear' size="small" style={{ display: 'grid' }}>
                        <IonIcon slot="icon-only" icon={wrong} />
                    </IonButton>
                }
                {dropdown &&

                    <IonIcon icon={chevronDownOutline} />
                }
            </IonItem>
            {error && <>
                {typeof error == 'string' ?
                    <FieldError className="field-error" value={__(error)} />
                    :
                    <>{error.map(el => (
                        <FieldError className="field-error" value={__(el)} />
                    ))}
                    </>
                }
            </>}
        </>
    );
};
export default withTranslation(FieldWrapper);

